const ArcherHat = require('$/assets/images/hat/ArcherHat.png');
const BoaterHat = require('$/assets/images/hat/BoaterHat.png');
const CaptainHat = require('$/assets/images/hat/CaptainHat.png');
const ChefHat = require('$/assets/images/hat/ChefHat.png');
const ChiefHeaddress = require('$/assets/images/hat/ChiefHeaddress.png');
const CowboyHat = require('$/assets/images/hat/CowboyHat.png');
const DeerEar = require('$/assets/images/hat/DeerEar.png');
const DinosaurHat = require('$/assets/images/hat/DinosaurHat.png');
const DivingHelmet = require('$/assets/images/hat/DivingHelmet.png');
const ElephantHat = require('$/assets/images/hat/ElephantHat.png');
const ElfHat = require('$/assets/images/hat/ElfHat.png');
const EngineerHelmet = require('$/assets/images/hat/EngineerHelmet.png');
const FanHat = require('$/assets/images/hat/FanHat.png');
const FlamingoHat = require('$/assets/images/hat/FlamingoHat.png');
const FootballHelmet = require('$/assets/images/hat/FootballHelmet.png');
const FruitHat = require('$/assets/images/hat/FruitHat.png');
const FurHat = require('$/assets/images/hat/FurHat.png');
const GraduationCap = require('$/assets/images/hat/GraduationCap.png');
const JesterHat = require('$/assets/images/hat/JesterHat.png');
const KidCap = require('$/assets/images/hat/KidCap.png');
const KingCrown = require('$/assets/images/hat/KingCrown.png');
const KnightHelmet = require('$/assets/images/hat/KnightHelmet.png');
const MagicianHat = require('$/assets/images/hat/MagicianHat.png');
const SombreroHat = require('$/assets/images/hat/SombreroHat.png');
const Paperbag = require('$/assets/images/hat/Paperbag.png');
const PartyHat = require('$/assets/images/hat/PartyHat.png');
const PharaohHat = require('$/assets/images/hat/PharaohHat.png');
const ShamanHat = require('$/assets/images/hat/ShamanHat.png');
const ToyWinderHat = require('$/assets/images/hat/ToyWinderHat.png');
const UnicornHat = require('$/assets/images/hat/UnicornHat.png');

exports.png = {
  'Archer': ArcherHat,
  'Boater': BoaterHat,
  'Captain': CaptainHat,
  'Chef': ChefHat,
  'Chief': ChiefHeaddress,
  'Cowboy': CowboyHat,
  'DeerEar': DeerEar,
  'Dinosaur': DinosaurHat,
  'Diving': DivingHelmet,
  'Elephant': ElephantHat,
  'Elf': ElfHat,
  'Engineer': EngineerHelmet,
  'Fan': FanHat,
  'Flamingo': FlamingoHat,
  'Football': FootballHelmet,
  'Fruit': FruitHat,
  'Fur': FurHat,
  'Graduation': GraduationCap,
  'Jester': JesterHat,
  'Cap': KidCap,
  'King': KingCrown,
  'Knight': KnightHelmet,
  'Magician': MagicianHat,
  'Sombrero': SombreroHat,
  'Paperbag': Paperbag,
  'Party': PartyHat,
  'Pharaoh': PharaohHat,
  'Shaman': ShamanHat,
  'Winder': ToyWinderHat,
  'Unicorn': UnicornHat,
};
